var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMana12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-213.43 -44.642)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6 0 0 6 4623.4 674.65)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -685,
    cy: -55.002,
    r: 50,
    fill: "#cac5c0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m427.21 159.94v295.08c0 35.25 14.568 52.896 43.662 52.896h7.6682v20.67h-157.11v-20.67h9.198c29.628 0 44.436-17.646 44.436-52.896v-193.92c0-35.73-12.258-53.634-36.768-53.634h-16.092v-19.932h6.1145c30.654 0 58.254-9.186 82.77-27.588l16.122-7e-3zm305.79 278.2-26.826 91.218h-224.57v-19.92c10.758-12.258 34.494-36.798 71.292-73.596 21.954-21.96 43.944-45.468 65.928-70.488 10.728-12.294 19.146-22.488 25.29-30.69 12.756-19.392 19.146-38.79 19.146-58.218 0-19.428-5.8862-36.552-17.628-51.366-11.754-14.826-27.354-22.23-46.746-22.23-40.386 0-72.072 27.588-95.058 82.794l-19.926-7.674c27.606-76.65 70.512-114.98 128.77-114.98 28.602 0 53.142 9.726 73.572 29.13 20.424 19.428 30.654 43.686 30.654 72.822 0 37.29-21.204 73.572-63.588 108.85l-43.692 35.238c-28.128 23.52-51.366 45.75-69.768 66.666-1.5238 1.572-4.0859 4.374-7.638 8.46h117.26c17.874 0 31.152-3.342 39.858-9.984 8.6701-6.612 16.596-18.642 23.736-36.024h19.938z",
    fill: "#0d0f0f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana12);
export default __webpack_public_path__ + "static/media/mana12.870dc8991d36a5c0c62151cc2bcc0d13.svg";
export { ForwardRef as ReactComponent };